import { createAction, props } from '@ngrx/store';
import { ConfigValues } from '../../config/models/config.model';
import { projectVideoAdapter } from './project-video.adapter';

export const adapterActions = projectVideoAdapter.getActions();

const updatePreviewClicked = createAction(
  '[Project Video] Update Preview Clicked',
  props<{ configValues: ConfigValues }>(),
);

const reconnectClicked = createAction(
  '[Project Video Error] Reconnect Clicked',
  props<{ configValues: ConfigValues }>(),
);

const repeatInteractionModeClicked = createAction(
  '[Project Video] Repeat Interaction Mode Clicked',
);

export const ProjectVideoActions = {
  ...adapterActions,
  updatePreviewClicked,
  reconnectClicked,
  repeatInteractionModeClicked,
};
